import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      return;
    }

    setFormStatus('submitting');
    setFormError('');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9q33rcnlsngrm4llqng', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } = {};
      try {
        parsed = JSON.parse(responseText);
      } catch {
        // ignore parse errors
      }

      if (response.ok && parsed.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setFormError('提交失败，请稍后再试');
        } else {
          setFormError(serverMsg || '提交失败，请稍后再试');
        }
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    }
  };

  const faqData = [
    {
      question: '爆料吃瓜的内容来源是什么？',
      answer: '我们的内容来源于多渠道信息整合，包括社交媒体爆料、娱记前线报道、业内人士投稿以及用户匿名投稿。所有内容均经过编辑团队核实后发布，确保信息的真实性和时效性。',
    },
    {
      question: '如何向爆料吃瓜投稿？',
      answer: '你可以通过本页底部的联系表单提交爆料线索，或直接发送邮件至 tips@bagua-news.com。我们承诺对所有投稿人信息严格保密，优质爆料一经采用还将获得丰厚稿酬。',
    },
    {
      question: '网站内容多久更新一次？',
      answer: '爆料吃瓜实行7×24小时全天候更新机制，编辑团队实时监控全网热点，确保第一时间为你呈现最新瓜料。重大爆料事件发生时会启动紧急报道流程，实现分钟级响应。',
    },
    {
      question: '如何举报不实信息？',
      answer: '如果你发现网站存在不实信息或侵权内容，请通过联系表单或邮件进行举报。我们会在收到举报后24小时内进行核实处理，确有不实内容的将立即更正或删除。',
    },
    {
      question: '爆料吃瓜支持手机端访问吗？',
      answer: '当然支持！爆料吃瓜采用响应式设计，完美适配手机、平板和桌面端。你也可以将网站添加到手机主屏幕，像使用App一样方便地随时随地吃瓜。',
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于我们 - 爆料吃瓜',
    description: '爆料吃瓜平台汇聚全网最新、最热、最劲爆的娱乐八卦与社会热点，致力于为吃瓜群众提供第一手瓜料资讯。',
    url: 'https://bagua.example.com/about',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '爆料吃瓜',
    url: 'https://bagua.example.com/',
    description: '爆料吃瓜平台汇聚全网最新、最热、最劲爆的娱乐八卦与社会热点',
    foundingDate: '2023-06-18',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: 'customer service',
      email: 'tips@bagua-news.com',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: '媒体大道188号',
      addressLocality: '北京',
      addressRegion: '朝阳区',
      addressCountry: 'CN',
    },
  };

  return (
    <>
      <head>
        <title>关于我们 - 爆料吃瓜</title>
        <meta name="description" content="爆料吃瓜平台汇聚全网最新娱乐八卦与社会热点。了解我们的品牌故事、团队理念，与我们取得联系，随时提供爆料线索。" />
        <meta name="keywords" content="爆料吃瓜,关于我们,品牌介绍,联系我们,吃瓜平台" />
        <link rel="canonical" href="https://bagua.example.com/about" />
        <meta property="og:title" content="关于我们 - 爆料吃瓜" />
        <meta property="og:description" content="了解爆料吃瓜的品牌故事与团队理念，汇聚全网最新娱乐八卦与社会热点。" />
        <meta property="og:url" content="https://bagua.example.com/about" />
        <meta property="og:type" content="website" />
      </head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          {/* Hero Banner */}
          <section className="w-full px-4 md:px-6 pb-14">
            <div className="relative rounded-2xl overflow-hidden bg-background-950 h-[300px] md:h-[400px] flex items-center justify-center">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20media%20newsroom%20with%20warm%20ambient%20lighting%2C%20multiple%20computer%20screens%20displaying%20news%20content%2C%20creative%20workspace%20with%20exposed%20brick%20walls%2C%20industrial%20chic%20design%2C%20warm%20golden%20and%20amber%20tones%2C%20professional%20yet%20casual%20atmosphere&width=1600&height=800&seq=about-hero&orientation=landscape"
                alt="爆料吃瓜编辑团队"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/70"></div>
              <div className="relative z-10 text-center px-4">
                <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-4">
                  关于爆料吃瓜
                </h1>
                <p className="text-base md:text-lg text-background-200/80 max-w-2xl mx-auto">
                  汇聚全网最新最热的娱乐八卦与社会热点，做一个有态度的吃瓜平台
                </p>
              </div>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="w-full px-4 md:px-6 pb-14">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
                品牌故事
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <p className="text-foreground-700 leading-relaxed">
                    <strong className="text-foreground-900">爆料吃瓜</strong>成立于2023年，是中国领先的娱乐八卦与社会热点聚合平台。我们的使命是：让每一个吃瓜群众都能第一时间吃到最新鲜、最真实的瓜。
                  </p>
                  <p className="text-foreground-700 leading-relaxed">
                    在这个信息爆炸的时代，我们深知用户需要的不仅是速度，更是真实与深度。因此，爆料吃瓜建立了一支专业的编辑与核实团队，确保每一条爆料都经过多方验证后才与大家见面。
                  </p>
                  <p className="text-foreground-700 leading-relaxed">
                    我们相信，吃瓜不只是一种消遣，更是一种社交方式。通过爆料吃瓜，你可以与千万瓜友一起讨论、分享、交流，让吃瓜体验变得更加有趣。
                  </p>
                </div>
                <div className="rounded-xl overflow-hidden aspect-[4/3]">
                  <img
                    src="https://readdy.ai/api/search-image?query=A%20creative%20team%20brainstorming%20in%20a%20modern%20office%20with%20warm%20lighting%2C%20sticky%20notes%20on%20glass%20wall%2C%20collaborative%20workspace%2C%20diverse%20young%20professionals%2C%20casual%20tech%20startup%20vibe%2C%20warm%20amber%20and%20wood%20tones&width=800&height=600&seq=about-team&orientation=landscape"
                    alt="爆料吃瓜团队"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Stats */}
          <section className="w-full px-4 md:px-6 pb-14">
            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { value: '5000万+', label: '月活用户', icon: 'ri-user-star-line' },
                  { value: '10万+', label: '累计爆料', icon: 'ri-article-line' },
                  { value: '99.7%', label: '信息准确率', icon: 'ri-shield-check-line' },
                  { value: '24小时', label: '全天候更新', icon: 'ri-timer-flash-line' },
                ].map((stat) => (
                  <div
                    key={stat.label}
                    className="bg-background-50 border border-background-200/60 rounded-xl p-5 text-center"
                  >
                    <span className="inline-flex w-10 h-10 items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-3">
                      <i className={`${stat.icon} text-lg`}></i>
                    </span>
                    <div className="text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
                      {stat.value}
                    </div>
                    <div className="text-sm text-foreground-600">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section className="w-full px-4 md:px-6 pb-14">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    quote: '爆料吃瓜是我每天必刷的网站，瓜料更新速度真的快，好几次都是在这里第一时间看到热搜事件，身边朋友都问我在哪看的。',
                    name: '资深吃瓜群众小王',
                    icon: 'ri-user-3-line',
                  },
                  {
                    quote: '以前总要在各个平台来回切换找瓜吃，自从有了爆料吃瓜，一个网站就搞定了。内容真实度高，不是那种随便编的营销号。',
                    name: '娱乐记者老张',
                    icon: 'ri-user-3-line',
                  },
                  {
                    quote: '界面简洁舒服，没有乱七八糟的广告弹窗。文章写得也很有深度，不只是简单的爆料，还有分析和解读，很喜欢这种风格。',
                    name: '互联网从业者阿琳',
                    icon: 'ri-user-3-line',
                  },
                ].map((item) => (
                  <div
                    key={item.name}
                    className="bg-background-50 border border-background-200/60 rounded-xl p-6"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      &ldquo;{item.quote}&rdquo;
                    </p>
                    <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                      <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500">
                        <i className={item.icon}></i>
                      </span>
                      <span className="text-sm font-medium text-foreground-900">{item.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact Form */}
          <section className="w-full px-4 md:px-6 pb-14">
            <div className="max-w-2xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4 text-center">
                联系我们
              </h2>
              <p className="text-foreground-600 text-center mb-8">
                有爆料线索？想合作推广？或者有任何建议？欢迎随时联系我们！
              </p>

              <form
                onSubmit={handleSubmit}
                data-readdy-form="true"
                className="bg-background-50 border border-background-200/60 rounded-xl p-6 md:p-8 space-y-5"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      姓名 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入你的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-foreground-800 mb-1.5">
                      邮箱 <span className="text-primary-500">*</span>
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入你的邮箱"
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    主题 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    required
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                    placeholder="请输入主题"
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-foreground-800 mb-1.5">
                    留言内容 <span className="text-primary-500">*</span>
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    maxLength={500}
                    rows={5}
                    className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                    placeholder="请输入你的留言，最多500字"
                  ></textarea>
                  <p className="text-xs text-foreground-500 mt-1 text-right">最多500字</p>
                </div>
                <div className="honeypot-field">
                  <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden={true} readOnly={true} />
                </div>

                {formStatus === 'success' && (
                  <div className="flex items-center gap-2 p-4 rounded-lg bg-green-50 text-green-700 text-sm">
                    <i className="ri-checkbox-circle-line text-lg"></i>
                    提交成功！我们会尽快与你取得联系。
                  </div>
                )}
                {formStatus === 'error' && (
                  <div className="flex items-center gap-2 p-4 rounded-lg bg-red-50 text-red-700 text-sm">
                    <i className="ri-error-warning-line text-lg"></i>
                    {formError}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={formStatus === 'submitting'}
                  className="w-full py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors whitespace-nowrap cursor-pointer"
                >
                  {formStatus === 'submitting' ? (
                    <span className="flex items-center justify-center gap-2">
                      <i className="ri-loader-4-line animate-spin"></i> 提交中...
                    </span>
                  ) : (
                    '提交留言'
                  )}
                </button>
              </form>
            </div>
          </section>

          {/* FAQ */}
          <section className="w-full px-4 md:px-6 pb-16">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center">
                常见问题
              </h2>
              <div className="space-y-3">
                {faqData.map((faq, index) => (
                  <details
                    key={index}
                    className="group bg-background-50 border border-background-200/60 rounded-xl overflow-hidden"
                  >
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                      <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
                      <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-500 transition-colors">
                        <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                      </span>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}